type OrderingFieldType = string | number | Date | undefined | null;

export const getSort = (
  a: OrderingFieldType,
  b: OrderingFieldType,
  ordering: "az" | "za" | undefined
): number => {
  if (!ordering || a === undefined || b === undefined || a === null || b === null) return 0;

  const isAscending = ordering === "az";

  if (typeof a === "string" && typeof b === "string") {
    return isAscending ? a.localeCompare(b) : b.localeCompare(a);
  }

  if (typeof a === "number" && typeof b === "number") {
    return isAscending ? a - b : b - a;
  }

  const dateA = new Date(a);
  const dateB = new Date(b);

  if (!isNaN(dateA.getTime()) && !isNaN(dateB.getTime())) {
    return isAscending ? dateA.getTime() - dateB.getTime() : dateB.getTime() - dateA.getTime();
  }

  return 0;
};
